module.exports = __webpack_public_path__ + "media/public/img/tripadvisor_background-ebb97188f8c6c657a79ad20e0caa6051.svg";